var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3297 3.3L13.5413 16.1053C13.5343 16.4565 13.3917 16.7913 13.1434 17.0396C12.895 17.288 12.5602 17.4305 12.2091 17.4375H5.30344C4.9523 17.4305 4.61748 17.288 4.36914 17.0396C4.12079 16.7913 3.97821 16.4565 3.97125 16.1053L3.18281 3.3M1.6875 3.3H15.825H1.6875ZM6.0375 3.3V2.18531C6.0375 1.9041 6.14921 1.63441 6.34806 1.43556C6.54691 1.23671 6.8166 1.125 7.09781 1.125H10.4147C10.5539 1.125 10.6918 1.15243 10.8205 1.20571C10.9491 1.259 11.066 1.3371 11.1644 1.43556C11.2629 1.53402 11.341 1.65091 11.3943 1.77955C11.4476 1.90819 11.475 2.04607 11.475 2.18531V3.3H6.0375Z",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4749 5.47485L10.9311 15.2624M8.7561 5.47485V15.2624V5.47485ZM6.03735 5.47485L6.5811 15.2624L6.03735 5.47485Z",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.978b6a15fd9649508a0dc1baf0b20d97.svg";
export { ForwardRef as ReactComponent };